import React from "react";
import { AppConfig } from "../../../app-state";
import { Money } from "../../../core/Money";
import { NavLink } from "react-router-dom";
import { Icon } from "../../../core/Icon";
import moment from "moment";
import { getProlongationLabel } from "../../../enums/prolongationOptions";
import { Countdown } from "./Countdown";
import classNames from "classnames";
export const EventStripItem = (props) => {
    const { id, thumb, title, refno, start, lowest_bid, prolongation_time, status, assurance, price } = props.item;
    const { eventIdEnrollments } = props;
    const eventUrl = '/cs/aukce/' + id;
    return (React.createElement("div", { className: classNames("event-strip-item", { "cancelled": status == 'cancelled', "image-tbd": !thumb }) },
        React.createElement("div", { className: "es-inner" },
            React.createElement(NavLink, { to: eventUrl, className: "es-thumb", style: { backgroundImage: 'url(' + AppConfig.filesPrefix + thumb + ')' } },
                props.stateFilter == 'closed' && (price ? React.createElement("span", { className: "es-badge is-sold" }, "Prod\u00E1no") : React.createElement("span", { className: "es-badge is-not" }, "Neprod\u00E1no")),
                React.createElement("div", { className: "es-thumb-overlay", "aria-hidden": true }),
                React.createElement("div", { className: "es-thumb-overlayh", "aria-hidden": true }),
                React.createElement("div", { className: "es-lowest-bid" }, price ?
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "eslbl" }, "Nejvy\u0161\u0161\u00ED nab\u00EDdka"),
                        React.createElement(Money, { cssWrapper: "eslbf", amount: price, decimals: 0 }))
                    :
                        React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "eslbl" }, "Nejni\u017E\u0161\u00ED pod\u00E1n\u00ED"),
                            lowest_bid ? React.createElement(Money, { cssWrapper: "eslbf", amount: lowest_bid, decimals: 0 }) : 'Nestanoveno'))),
            (props.stateFilter == 'my' || (eventIdEnrollments && eventIdEnrollments.includes(id))) && React.createElement("div", { className: "es-enrolled" }, "\u00DA\u010Dastn\u00EDte se"),
            React.createElement("div", { className: "es-body" },
                React.createElement(NavLink, { to: eventUrl, className: "es-title" }, title),
                React.createElement("div", { className: "es-refno" },
                    "\u010C\u00EDslo jednac\u00ED: ",
                    refno ? refno : 'Nestanoveno')),
            React.createElement("div", { className: "es-conditions" }, status == 'cancelled' ?
                React.createElement("div", { className: "conl" },
                    React.createElement(Icon, { c: ['website-problem', 16, 16] }),
                    React.createElement("span", { className: "conlv" }, "Zru\u0161eno"))
                :
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "conl" },
                            React.createElement(Icon, { c: ['calendar', 16, 16] }),
                            React.createElement("span", { className: "conlv" }, start ? moment.unix(start).format('D. M. YYYY, HH:mm') : 'Nestanoveno')),
                        React.createElement("div", { className: "conl" },
                            React.createElement(Icon, { c: ['sand-clock', 16, 16] }),
                            React.createElement("span", { className: "conlv" },
                                React.createElement(Countdown, { start: start }))),
                        React.createElement("div", { className: "conl" },
                            React.createElement(Icon, { c: ['stopwatch', 16, 16] }),
                            React.createElement("span", { className: "conlv" }, getProlongationLabel(prolongation_time))),
                        React.createElement("div", { className: "conl" },
                            React.createElement(Icon, { c: ['coins', 16, 16] }),
                            React.createElement("span", { className: "conlv" }, assurance ? React.createElement(Money, { amount: assurance }) : 'Nestanoveno')))))));
};
